<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.contract.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="起始时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.startSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.endSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item> -->
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-col">
          <el-form-item label="开始时间：" prop="startCreateTime">
            <el-date-picker type="date" v-model="filterForm.startCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
          <el-form-item label="结束时间：" prop="endCreateTime">
            <el-date-picker type="date" v-model="filterForm.endCreateTime" value-format="timestamp" placeholder="选择日期" />
          </el-form-item>
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
          <el-button @click="clickMenu('Form_grxxcj'),$router.push('/Form_grxxcj')">详细数据</el-button>
        </div>
      </el-form>
    </section>
    <section class="section-form">
      <el-form :model="ruleForm" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="x.label+'：'" v-for="(x,i) in formLabels" :key="i">
          <span>{{ruleForm[x.key]}}</span>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
import AreaPicker from '@/components/AreaPicker'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins],
  components: { AreaPicker },
  data() {
    return {
      formLabels: [
        { label: '18-30', key: 'ageRange18To30' },
        { label: '31-40', key: 'ageRange31To40' },
        { label: '41-50', key: 'ageRange41To50' },
        { label: '51-60', key: 'ageRange51To60' },
        { label: '高中以下', key: 'educationHighSchool' },
        { label: '中专', key: 'educationSecondary' },
        { label: '专科', key: 'educationUniversity3' },
        { label: '本科', key: 'educationUniversity4' },
        { label: '硕士及以上', key: 'educationMaster' },
      ],
      ruleForm: {
        ageRange18To30: '', //18到30
        ageRange31To40: '', //31到40
        ageRange41To50: '', //41到50
        ageRange51To60: '', //51到60
        educationHighSchool: '', //高中以下
        educationSecondary: '', //中专
        educationUniversity3: '', //专科
        educationUniversity4: '', //本科
        educationMaster: '', //硕士及以上
      }
    }
  },
  methods: {
    getData(rD = {}) {
      rD.reportType = 1
      this.$api.report_get(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          if (_R.length) {
            this.ruleForm.ageRange18To30 = _R[0].ageRange18To30
            this.ruleForm.ageRange31To40 = _R[0].ageRange31To40
            this.ruleForm.ageRange41To50 = _R[0].ageRange41To50
            this.ruleForm.ageRange51To60 = _R[0].ageRange51To60
          }
        } else { this._status(res.data) }
      })
      rD.reportType = 2
      this.$api.report_get(rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          if (_R.length) {
            this.ruleForm.educationHighSchool = _R[0].educationHighSchool
            this.ruleForm.educationSecondary = _R[0].educationSecondary
            this.ruleForm.educationUniversity3 = _R[0].educationUniversity3
            this.ruleForm.educationUniversity4 = _R[0].educationUniversity4
            this.ruleForm.educationMaster = _R[0].educationMaster
          }
        } else { this._status(res.data) }
      })
    },
  },
  // created() {
  //   const powerList = this.userInfo.privilegesList
  //   const powerStr = powerMap[this.sign]
  //   // console.log(powerStr)
  //   this.btnShow.search = true
  //   const mapList = ['export']
  //   if (this.userInfo.admin) {
  //     mapList.forEach(x => {
  //       this.btnShow[x] = true
  //     })
  //   } else {
  //     mapList.forEach(x => {
  //       if (x && powerList.includes(powerStr + '-' + x)) {
  //         this.btnShow[x] = true
  //       }
  //     })
  //   }
  // },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}

.section-form{padding: 80px;}
</style>